(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerOverlayActive = document.body.classList.contains('ec-header-overlay-active');
      this.headerBounds = {};

      this.setupStickyContainer();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 1280px)').addEventListener('change', this.onBreakpointChange.bind(this));

      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      const announcementSection = document.querySelector('.announcement-bar-section');
      if (announcementSection) this.headerResizeObserver.observe(announcementSection);
      if (this.header) this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky || this.headerOverlayActive) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search') || this.querySelector('ec-predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // Wraps the announcement bar + header in one container and freezes its
    // height as an explicit px value captured after their first real render.
    // An explicit height never shrinks/grows just because a child inside it
    // resizes (e.g. the header collapsing to compact, or a stray script
    // recalculating something) — unlike the old approach of a spacer sized via
    // a live CSS custom property, which any unrelated resize could silently
    // corrupt and shift the rest of the page. With a frozen container height,
    // the space the container occupies in the page is fixed for good the
    // moment this runs; nothing that happens inside it afterward (entering or
    // leaving compact) can ever change how much room it takes up.
    setupStickyContainer() {
      const announcement = document.querySelector('.announcement-bar-section');
      if (!this.header || !announcement) return;
      if (this.header.parentNode && this.header.parentNode.classList.contains('ec-sticky-header-container')) {
        this.stickyContainer = this.header.parentNode;
        return;
      }

      const container = document.createElement('div');
      container.className = 'ec-sticky-header-container';
      announcement.parentNode.insertBefore(container, announcement);
      container.appendChild(announcement);
      container.appendChild(this.header);
      this.stickyContainer = container;

      this.freezeContainerHeight();
      // Re-freeze once after full load (images/fonts settled) in case the
      // very first measurement ran before layout was fully final.
      window.addEventListener('load', () => this.freezeContainerHeight(), { once: true });
    }

    freezeContainerHeight() {
      if (!this.stickyContainer || this.header.classList.contains('ec-header-compact')) return;
      this.stickyContainer.style.height = 'auto';
      const height = this.stickyContainer.offsetHeight;
      this.stickyContainer.style.height = height + 'px';
    }

    setHeaderHeight() {
      if (this.header && this.header.classList.contains('ec-header-compact')) return;

      const announcementSection = document.querySelector('.announcement-bar-section');
      const headerSection = document.querySelector('.section-header');
      let totalHeight = 0;
      if (announcementSection) totalHeight += announcementSection.offsetHeight;
      if (headerSection) totalHeight += headerSection.offsetHeight;
      document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerResizeObserver) {
        this.headerResizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onBreakpointChange() {
      this.exitCompact();
      this.freezeContainerHeight();
      this.setHeaderHeight();
    }

    // Pins the header as a short, collapsed compact bar (menu hidden,
    // announcement bar hidden) — the "always" sticky look while scrolled. The
    // ec-sticky-header-container's frozen height (see setupStickyContainer)
    // already reserves the full space regardless, so there's no spacer to
    // create here anymore.
    enterCompact() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      var announcement = document.querySelector('.announcement-bar-section');
      if (announcement) announcement.classList.add('ec-announcement-hidden');

      this.header.classList.add('ec-header-compact');
      this.header.classList.remove('ec-header-compact-out');

      void this.header.offsetHeight;
      this.header.classList.add('ec-header-compact-in');
    }

    // Hands the header back to normal document flow and reveals the menu +
    // announcement bar. Only ever called once scrollTop is (effectively) 0 —
    // see updateCompactBar — because while scrolled deep into the page,
    // switching back to static would make the header scroll out of view
    // immediately (it no longer clings to the viewport), which would look like
    // it vanished. At scrollTop 0 the static position and the pinned position
    // are the same place, so the position swap itself is invisible; the only
    // visible change left is the menu/announcement bar reappearing, which is
    // unavoidable now that they're hidden while scrolled.
    exitCompact() {
      if (!this.header.classList.contains('ec-header-compact')) return;

      // Force the menu's reveal to be instantaneous rather than letting the
      // base .header__inline-menu transition animate it: this header is about
      // to be back in normal document flow, so an animated height change here
      // would visibly push whatever comes after it for the duration.
      var inlineMenu = this.header.querySelector('.header__inline-menu');
      if (inlineMenu) inlineMenu.style.transition = 'none';

      this.header.classList.remove('ec-header-compact', 'ec-header-compact-in', 'ec-header-compact-out', 'scrolled-past-header');

      var announcement = document.querySelector('.announcement-bar-section');
      if (announcement) announcement.classList.remove('ec-announcement-hidden');

      this.setHeaderHeight();

      if (inlineMenu) {
        void inlineMenu.offsetHeight;
        requestAnimationFrame(() => {
          inlineMenu.style.transition = '';
        });
      }
    }

    updateCompactBar(scrollTop) {
      const isCompact = this.header.classList.contains('ec-header-compact');

      if (scrollTop > this.headerBounds.bottom) {
        if (!isCompact) this.enterCompact();
      } else if (isCompact && scrollTop <= 1) {
        this.exitCompact();
      }
    }

    onScroll() {
      if (document.body.classList.contains('ec-header-overlay-active')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.querySelector('[data-ec-mobile-search-panel][data-ec-mobile-search-open]')) return;

      this.updateCompactBar(scrollTop);

      if (this.header.classList.contains('ec-header-compact')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || document.body.classList.contains('ec-header-overlay-active')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || document.body.classList.contains('ec-header-overlay-active')) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || document.body.classList.contains('ec-header-overlay-active')) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.exitCompact();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
      if (this.predictiveSearch && this.predictiveSearch.isOpen) this.predictiveSearch.close();
      this.querySelectorAll('[data-ec-mobile-search-overlay]').forEach(function(overlay) {
        overlay.setAttribute('hidden', '');
        overlay.setAttribute('aria-hidden', 'true');
      });
      this.querySelectorAll('[data-ec-mobile-search-panel][data-ec-mobile-search-open]').forEach(function(panel) {
        panel.setAttribute('hidden', '');
        panel.removeAttribute('data-ec-mobile-search-open');
      });
      this.querySelectorAll('[data-ec-mobile-search-trigger]').forEach(function(trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
